<template>
    <van-pull-refresh v-model="DitctIsRefreshing" @refresh="getDictDetailData"
        style="height: 100%;width: 100%;overflow-y: auto;">
        <van-list v-model="DitctLoading" :finished="DitctFinished" finished-text="没有更多了">
            <div class="v " v-if="DitctData.length">
                <div class="h  c">
                    <van-icon v-if="mangeVisible" name="arrow-left" style="margin: 0 0.5rem;" size="18"
                        @click="mangeVisible = false" />
                    <van-icon v-else name="arrow-left" style="margin: 0 0.5rem;" size="18" @click="toBack" />
                    <h3>{{ mangeVisible ? '管线' : '分类' }}</h3>
                </div>
                <template v-if="!mangeVisible">
                    <van-cell v-for="item in DitctData" :key="item.id" :title="item.label"
                        @click="toGetMangageLine(item)" :clickable="true" :class="item.expanded ? 'bc-p fc-w' : ''" />
                </template>
                <template v-else>
                    <van-cell v-for="item in manageLineDitctData" :key="item.id" :title="item.label"
                        @click="toProVisible(item)" :clickable="true" :class="item.expanded ? 'bc-p fc-w' : ''" />
                </template>
            </div>
            <van-empty v-else description="暂无管线/分类信息" />
        </van-list>
    </van-pull-refresh>
</template>

<script>
import { getDictDetail, getManageLineData } from "@/api/project";

export default {

    data() {
        return {
            manageLineId: null,
            proClassificationId: null,
            manageLineDitctData: [],
            mangeVisible: false,
            DitctData: [],
            DitctLoading: false,
            DitctFinished: false,
            DitctIsRefreshing: false,
        }
    },
    methods: {
        toBack() {
            this.$router.push({ path: "/" })
        },
        getDictDetailData() {
            this.DitctLoading = true;
            this.proClassificationId = null
            getDictDetail({
                dictName: "pro_classification",
                current: 1,
                size: 999,
            })
                .then((res) => {
                    if (res.content.length > 0) {
                        this.proClassificationDictDetail = res.content.map((item) => {
                            return {
                                ...item,
                                expanded: false
                            }
                        });
                        this.proClassificationDictDetail.unshift({
                            id: null,
                            label: "全部",
                            expanded: false,
                            value: 'proClassification'
                        })
                        this.DitctData = this.proClassificationDictDetail;
                        this.DitctFinished = true;
                        this.DitctIsRefreshing = false;
                        this.UpDateExpanded();

                    }

                })
                .catch((err) => {
                    this.$message.error(err);
                });
        },
        toGetMangageLine(data) {
            this.DitctFinished = false;
            this.mangeVisible = true
            this.manageLineDitctData = []
            if (data.label != '全部') {
                this.proClassificationDictDetail.forEach((item) => {
                    if (data.id == item.id) {
                        item.expanded = true;
                    } else {
                        item.expanded = false;
                    }
                })
                this.proClassificationId = data.id;
            } else {
                this.proClassificationDictDetail.forEach((item) => {
                    if (data.label == item.label) {
                        item.expanded = true;
                    } else {
                        item.expanded = false;
                    }
                })
                this.proClassificationId = null;
            }
            getManageLineData({
                proClassificationId: this.proClassificationId,
                current: 1,
                size: 999,
            })
                .then((res) => {
                    if (res.content.length > 0) {
                        this.manageLineDitctData = res.content.map((item) => {
                            return {
                                ...item,
                                expanded: false
                            }
                        });
                        this.manageLineDitctData.unshift({
                            id: null,
                            label: "全部",
                            expanded: false,
                            value: 'manageLine',
                        })
                        if (this.$route.query.manageLineId) {
                            this.manageLineDitctData.forEach((item) => {
                                if (this.$route.query.manageLineId == item.id) {
                                    item.expanded = true;
                                } else {
                                    item.expanded = false;
                                }
                            })
                        }else{
                            this.manageLineDitctData[0].expanded = true;
                        }
                        this.DitctFinished = true;
                    }
                })
        },
        toProVisible(data) {
            if (data.label != '全部') {
                this.manageLineDitctData.forEach((item) => {
                    if (data.id == item.id) {
                        item.expanded = true;
                    } else {
                        item.expanded = false;
                    }
                })
                this.manageLineId = data.id;

            } else {
                this.manageLineDitctData.forEach((item) => {
                    if (data.label == item.label) {
                        item.expanded = true;
                    } else {
                        item.expanded = false;
                    }
                })
                this.manageLineId = null;
            }
            this.$router.push({
                path: "/project",
                query: {
                    manageLineId: this.manageLineId,
                    proClassificationId: this.proClassificationId,
                }
            });
        },
        UpDateExpanded() {
            if (this.$route.query.proClassificationId) {
                this.proClassificationId = this.$route.query.proClassificationId;
                this.mangeVisible = false;
                this.proClassificationDictDetail.forEach((item) => {
                    if (this.proClassificationId == item.id) {
                        item.expanded = true;
                    } else {
                        item.expanded = false;
                    }
                })
            }else{
                this.proClassificationDictDetail[0].expanded = true;
            }
        }

    },
    mounted() {
        this.getDictDetailData();

    },
}
</script>

<style></style>